<template>
    <div class="major_home">
        <div class="courses1">
            <div class="c1_cont">
                <div class="cn">艺术专业</div>
                <div class="en">ART MAJOR</div>
            </div>
        </div>

        <div class="major2">
            <div class="m2_cont">
                <div class="m2_left">
                    <p class="en">POPULAR MAJORS</p>
                    <p class="cn">热 门 专 业</p>
                </div>
                <div class="m2_right">
                    <div class="m2_item" @click="jopMajorDetail(2)">
                        <img src="../img/艺术专业/Group 518.png" alt="">
                        <p>服装设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(15)">
                        <img src="../img/艺术专业/Group 519.png" alt="">
                        <p>景观设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(19)">
                        <img src="../img/艺术专业/Group 512.png" alt="">
                        <p>工业设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(8)">
                        <img src="../img/艺术专业/Group 513.png" alt="">
                        <p>插画设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(4)">
                        <img src="../img/艺术专业/Group 514.png" alt="">
                        <p>动画设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(13)">
                        <img src="../img/艺术专业/Group 515.png" alt="">
                        <p>建筑设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(20)">
                        <img src="../img/艺术专业/Group 516.png" alt="">
                        <p>交互设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(16)">
                        <img src="../img/艺术专业/Group 517.png" alt="">
                        <p>室内设计</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="major3">
            <div class="section_box">
                <div class="section_title_cn">专业分类</div>
                <div class="section_title_en">MAJOR CATEGORIES</div>
            </div>
            <div class="m3_cont">
                <div class="m3_cont_item" v-for="(item, index) in germList">
                    <div class="m3_acade_top">
                        <div class="m3_acade_cn">{{ item.cname }}</div>
                        <div class="m3_acade_en">{{ item.ename }}</div>
                    </div>
                    <div class="m3_item_box">
                        <div class="m3_item" v-for="(item2, index2) in item.get_major" @click="jopMajorDetail(item2.id)">
                            <img :src="'https://public.rossoarts.com/static/uploads/' + item2.image" alt="">
                            <p class="cn">{{ item2.cname }}</p>
                            <p class="en">{{ item2.ename }}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="major4">
            <div class="nav_bottom">
                <table>
                    <tr class="one">
                        <td class="right_bd bottom_bd"><p @click="scrollGerm(0)">时尚设计系</p></td>
                        <td class="right_bd bottom_bd"><p @click="scrollGerm(1)">视觉艺术系</p></td>
                        <td class="bottom_bd"><p @click="scrollGerm(2)">数字媒体系</p></td>
                        
                    </tr>
                    <tr class="two">
                        <td class="right_bd"><p @click="scrollGerm(3)">工业建筑系</p></td>
                        <td class="right_bd"><p @click="scrollGerm(4)">艺术商科系</p></td>
                        <td><p @click="scrollGerm(5)">通识艺术系</p></td>
                        
                    </tr>
                </table>
            </div>
        </div>
        <!-- 最外层div -->
    </div>
</template>
<script>
import '@/assets/css/major.css'

import axios from "axios"
export default {
    data() {
        return {
            germList: []
        }
    },
    created() {
        this.getMajor()
       
    },
    methods: {
      
        jopMajorDetail(val){
            this.$router.push(`/majors/${val}.html`)
        },
        getMajor() {
            axios.get("https://public.rossoarts.com/api/v1/getSubject").then((data) => {
                // console.log(data.data.data);

                this.germList = data.data.data.sort(function (a, b) {
                    return a.sort - b.sort
                })
                // console.log(this.germList);
            })
        },
        scrollGerm(val) {
            // console.log(val);
            var m3_cont_item = document.getElementsByClassName('m3_cont_item')
            // console.log(m3_cont_item[val].offsetTop);
           if(m3_cont_item[val].offsetTop){

               window.scroll(0,m3_cont_item[val].offsetTop - 360)
            }

        },
        windowScroll() {
            var nav_bottom = document.getElementsByClassName("nav_bottom")
            var m3_cont_item = document.getElementsByClassName('m3_cont_item')
        
            this.$nextTick(() => {
                var ot = m3_cont_item[1].offsetTop
                var st = document.documentElement.scrollTop;
                // console.log(ot, st);
                if (st > ot - 200) {
                    // console.log("iiiiii")
                    nav_bottom[0].style.display = "none"
                    nav_bottom[1].style.height = "1.6rem"
                }else{
                    nav_bottom[0].style.display = "flex"
                    nav_bottom[1].style.height = "0rem"
                }
            })
           

        }
    },
    mounted() {
        window.addEventListener("scroll", this.windowScroll, true);
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll, true);
    },
}
</script>